// https://docs.google.com/spreadsheets/d/1XCX3id3FEEiMHmmF2wkucZeW_GAYnvSQJ-1ox_Zrzps/edit#gid=2122343373

import unset from "lodash.unset";
import React from "react";
import { ACTIONS } from "../../../../constants";
import Button from "../../../components/Button";
import Card from "../../../components/Card";
import Form from "../../../components/Form";
import InputCurrency from "../../../components/InputCurrency";
import InputRadioGroup from "../../../components/InputRadioGroup";
import useForm from "../../../hooks/useForm";
import { useMutateContractQuery } from "../../../hooks/useMutateContractQuery";
import AHReferralDecision from "./AHReferralDecision";
import { adjustablePremiumOptions } from "./config";
import { asCurrencyCode, getVerbiage } from "./helpers";
import RatesTable from "./RatesTable";

const ReferralDecision = ({ className, contractData }) => {
  const { updateContract, contractId, productRef, isUpdating } = useMutateContractQuery({});
  const payrollBreakdown = contractData?.submission?.payroll?.payroll_breakdown;

  const { getFieldProps, formValues, onSubmit } = useForm({
    initialState: {},
    onBeforeChange: (clonedFormValues, name) => {
      if (name === "premium_type") {
        unset(clonedFormValues, "premium");
        unset(clonedFormValues, "deductible");
        unset(clonedFormValues, "adjustable_premium_option");
        unset(clonedFormValues, "adjustable_premium_type");
        unset(clonedFormValues, "adjustableRates");
      }

      if (name === "adjustable_premium_option") {
        unset(clonedFormValues, "adjustable_premium_type");
        unset(clonedFormValues, "adjustableRates");
      }

      if (name === "adjustable_premium_type") {
        unset(clonedFormValues, "adjustableRates");
        unset(clonedFormValues, "reduce_premium");
        unset(clonedFormValues, "reduced_premium");
      }
    },
    onSubmit: (values) => {
      const payload = getVerbiage({ formValues: values, payrollBreakdown });

      updateContract({
        productRef,
        contractId,
        data: { type: ACTIONS.PROVIDE_COMMERCIAL_PRICE, payload },
      });
    },
  });

  const adjustablePremiumTypes = adjustablePremiumOptions[formValues.adjustable_premium_option];
  const { verbiage, premium } = getVerbiage({ payrollBreakdown, formValues });

  return (
    <Card headingText="Next steps" className={className}>
      <div className="p-6">
        <Form onSubmit={onSubmit} id="decisionForm">
          <InputRadioGroup
            className="mb-8"
            isRequired
            labelText="Premium"
            options={["Flat premium", "Adjustable premium"]}
            {...getFieldProps("premium_type")}
          />

          {formValues.premium_type === "Flat premium" && (
            <>
              <InputCurrency
                className="mb-8"
                isRequired
                labelText="Premium"
                {...getFieldProps("premium")}
              />

              <InputCurrency
                className="mb-8"
                isRequired
                labelText="Deductible"
                {...getFieldProps("deductible")}
              />
            </>
          )}

          {formValues.premium_type === "Adjustable premium" && (
            <>
              <InputRadioGroup
                className="mb-8"
                isRequired
                labelText="Adjustable premium option"
                options={Object.keys(adjustablePremiumOptions)}
                {...getFieldProps("adjustable_premium_option")}
              />

              {formValues.adjustable_premium_option && (
                <>
                  <InputRadioGroup
                    className="mb-8"
                    isRequired
                    labelText="Adjustable premium type"
                    options={Object.keys(adjustablePremiumTypes)}
                    {...getFieldProps("adjustable_premium_type")}
                  />

                  {formValues.adjustable_premium_type && (
                    <>
                      <InputCurrency
                        className="mb-8"
                        isRequired
                        labelText="Deductible"
                        {...getFieldProps("deductible")}
                      />

                      <RatesTable
                        formValues={formValues}
                        getFieldProps={getFieldProps}
                        payrollBreakdown={payrollBreakdown}
                      />

                      <InputRadioGroup
                        className="mb-8"
                        isRequired
                        labelText="Reduce M&D premium?"
                        options={["Yes", "No"]}
                        {...getFieldProps("reduce_premium")}
                      />

                      {formValues.reduce_premium === "Yes" && (
                        <InputCurrency
                          className="mb-8"
                          isRequired
                          labelText="Actual M&D Premium amount"
                          {...getFieldProps("reduced_premium")}
                        />
                      )}

                      {verbiage && (
                        <>
                          <p className="mb-2">M&D Premium amount:</p>
                          <p className="mb-8 font-semibold">
                            {asCurrencyCode(premium)} {verbiage}
                          </p>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </>
          )}

          <div className="flex">
            <Button className="mr-4" isDisabled={isUpdating} kind="primary" type="submit">
              Submit
            </Button>
          </div>
        </Form>
      </div>
    </Card>
  );
};

export default process.env.DEFAULT_PRODUCT_REF === "ah" ? AHReferralDecision : ReferralDecision;
